import React, { useContext } from 'react';
import { useDisclosureState, Disclosure, DisclosureContent } from 'reakit/Disclosure';
import classNames from 'classnames';
import Heading from 'wienenergiedesignsystem/components/Heading/Heading';
import FontAwesomeProIcon from 'wienenergiedesignsystem/components/FontAwesome/FontAwesomeProIcon';
import Button from 'wienenergiedesignsystem/components/Button/Button';
import { AccordionContext } from 'wienenergiedesignsystem/components/Accordion/components/AccordionGroup/AccordionGroup';
import styles from 'wienenergiedesignsystem/components/Accordion/Accordion.module.scss';
export { default as AccordionGroup } from 'wienenergiedesignsystem/components/Accordion/components/AccordionGroup/AccordionGroup';
var Accordion = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _classNames;

  var title = _ref.title,
      subtitle = _ref.subtitle,
      anchor = _ref.anchor,
      children = _ref.children,
      isOpen = _ref.isOpen,
      index = _ref.index,
      className = _ref.className;
  var disclosure = useDisclosureState({
    visible: isOpen
  });
  var accordionState = useContext(AccordionContext);
  var isVisible = accordionState && !accordionState.allowMultiple ? index === accordionState.selectedIndex : disclosure.visible;

  var handleToggle = function handleToggle() {
    if (accordionState && !accordionState.allowMultiple) {
      if (!isVisible) {
        accordionState.setSelectedIndex(index);
      } else {
        accordionState.setSelectedIndex(-1);
      }

      return;
    }

    disclosure.toggle();
  };

  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: classNames(styles.accordion, className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement(Disclosure, Object.assign({
    id: anchor || undefined,
    as: Heading,
    size: "h6",
    noSpacing: true,
    className: styles.heading
  }, disclosure, {
    toggle: handleToggle
  }), title, subtitle && /*#__PURE__*/React.createElement("span", {
    className: styles.subtitle
  }, subtitle)), /*#__PURE__*/React.createElement(Disclosure, Object.assign({
    className: styles.toggle,
    as: Button,
    "aria-label": (isVisible ? 'Close' : 'Open') + " Accordion",
    shape: "bubble"
  }, disclosure, {
    toggle: handleToggle
  }), /*#__PURE__*/React.createElement(FontAwesomeProIcon, {
    icon: "chevron-down",
    role: "presentation",
    className: classNames(styles.arrow, (_classNames = {}, _classNames[styles.accordionOpen] = isVisible, _classNames))
  }))), /*#__PURE__*/React.createElement(DisclosureContent, Object.assign({}, disclosure, {
    visible: isVisible,
    className: styles.content
  }), children));
});
Accordion.defaultProps = {
  isOpen: false
};
export default Accordion;